/* unplugin-vue-components disabled */import { render } from "./App.vue?vue&type=template&id=35154208"
const script = {}

import "./App.vue?vue&type=style&index=0&id=35154208&lang=less"

import exportComponent from "D:\\work\\官网\\songjia\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__